module.exports = {
      id: "warning-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "assets/img/sprite-8cafc1.svg#warning-usage",
      toString: function () {
        return this.url;
      }
    }